module.exports = __webpack_public_path__ + "assets/img/android.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/android.png
// module id = 1931
// module chunks = 0